export default "__VITE_ASSET__4491b25a__"